module.exports = __webpack_public_path__ + "media/images/ticket/to_purchase_ov-56d48dd2c264f60fde7ceb784a15d399.png";